import { render, staticRenderFns } from "./NavDrawerNhapLieu.vue?vue&type=template&id=22d26a54"
import script from "./NavDrawerNhapLieu.vue?vue&type=script&lang=ts"
export * from "./NavDrawerNhapLieu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports